import { AgendamentoEspecialidadeComponent } from './agendamento-especialidade/agendamento-especialidade.component';
import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  { path: 'agendamento-especialidade', component: AgendamentoEspecialidadeComponent}
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)],
  exports: [
    RouterModule
  ]
})
export class RecepcaoRoutingModule { }
